import React from 'react';
import './login.css'
import LoginCard from '../components/LoginCard/';
import { Helmet } from 'react-helmet';

const login = () => {
  return (
      <div>
      <Helmet>
        <title>Login | ENT Chatbot</title>
      </Helmet>
      <div className='login-page'>
        <div className='login-container'>
          <LoginCard/>
        </div>
      </div>
      </div>
  );
};

export default login;